import React from 'react';
import { ZapIcon, CarIcon, CircleDotIcon, BoxIcon, FlagIcon, UtensilsIcon, PartyPopperIcon, MonitorIcon, TargetIcon, MicIcon, GamepadIcon, CircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const attractions = [{
  icon: ZapIcon,
  name: 'Indoor Trampoline Park',
  description: 'Bounce, flip, and soar through our massive trampoline arena with foam pits and dodgeball courts.',
  color: 'blue'
}, {
  icon: CarIcon,
  name: 'Go-Karting',
  description: 'Experience high-speed racing thrills on our professional indoor track.',
  color: 'orange'
}, {
  icon: CircleDotIcon,
  name: 'Duckpin Bowling',
  description: 'Classic bowling fun with a twist — smaller balls, more strikes, maximum fun.',
  color: 'yellow'
}, {
  icon: BoxIcon,
  name: 'BatBox',
  description: 'Step up to the plate in our state-of-the-art baseball simulator experience.',
  color: 'blue'
}, {
  icon: FlagIcon,
  name: 'Virtual Golf Simulator',
  description: 'Tee off rain or shine on world-famous courses from the comfort of indoors.',
  color: 'orange'
}, {
  icon: UtensilsIcon,
  name: 'Restaurant',
  description: 'Fuel up with delicious food and refreshing drinks for the whole family.',
  color: 'yellow'
}, {
  icon: PartyPopperIcon,
  name: 'Party Rooms',
  description: 'Private celebration spaces perfect for birthdays and special occasions.',
  color: 'blue'
}, {
  icon: MonitorIcon,
  name: 'PC Gaming Cafe',
  description: 'Level up your game on high-performance gaming PCs with the latest titles.',
  color: 'orange'
}, {
  icon: TargetIcon,
  name: 'Indoor Mini-Golf',
  description: 'Putt your way to victory through our creative themed course.',
  color: 'yellow'
}, {
  icon: MicIcon,
  name: 'Karaoke',
  description: 'Sing your heart out in our private karaoke rooms with friends and family.',
  color: 'blue'
}, {
  icon: GamepadIcon,
  name: 'Arcade Games',
  description: 'Classic and modern arcade games with tickets and prizes to win.',
  color: 'orange'
}, {
  icon: CircleIcon,
  name: 'Pool Tables',
  description: "Rack 'em up on our professional-grade billiards tables.",
  color: 'yellow'
}];
const colorClasses = {
  blue: 'border-t-pulse-blue bg-gradient-to-br from-pulse-blue/5 to-transparent',
  orange: 'border-t-pulse-orange bg-gradient-to-br from-pulse-orange/5 to-transparent',
  yellow: 'border-t-pulse-yellow bg-gradient-to-br from-pulse-yellow/5 to-transparent'
};
const iconColorClasses = {
  blue: 'text-pulse-blue bg-pulse-blue/10',
  orange: 'text-pulse-orange bg-pulse-orange/10',
  yellow: 'text-pulse-yellow bg-pulse-yellow/10'
};
export function AttractionsGrid() {
  return <section id="attractions" className="py-16 md:py-24 px-4 bg-gray-50" data-id="element-23">
      <div className="max-w-7xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-pulse-navy uppercase tracking-tight" data-id="element-26">
            What's Coming
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-27">
            12 incredible experiences are on their way. Here's a sneak peek at
            what you can expect.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-28">
          {attractions.map((attraction, index) => {
          const Icon = attraction.icon;
          return <motion.div key={attraction.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} whileHover={{
            y: -8,
            transition: {
              duration: 0.2
            }
          }} className={`bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow border-t-4 ${colorClasses[attraction.color as keyof typeof colorClasses]} p-6 relative`} data-id="element-29">
                <div className="absolute top-4 right-4 bg-pulse-orange/10 text-pulse-orange text-xs font-bold uppercase tracking-wider rounded-full px-2 py-0.5" data-id="element-30">
                  Coming Soon
                </div>
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 ${iconColorClasses[attraction.color as keyof typeof iconColorClasses]}`} data-id="element-31">
                  <Icon className="h-7 w-7" aria-hidden="true" data-id="element-32" />
                </div>
                <h3 className="text-xl font-bold text-pulse-navy mb-2 pr-20" data-id="element-33">
                  {attraction.name}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-34">
                  {attraction.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12" data-id="element-35">
          <a href="#signup" className="inline-flex items-center gap-2 bg-pulse-navy hover:bg-pulse-navy-light text-white px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all hover:scale-105" data-id="element-36">
            Get Notified When We Open
          </a>
        </motion.div>
      </div>
    </section>;
}